import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { User } from 'src/app/models/user';
import { LoginService } from '../../services/login.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {

  public user: User;
  public authError: boolean = false;
  public authEmpty: boolean = false;
  private code!: string;
  private returnUrlConstant: string = "returnUrl";
  private returnUrl!: string;
  public validating: boolean = false;
  Prod = environment.production;

  constructor(
    private router: Router,
    private service: LoginService,
    private http: HttpClient,
    private route: ActivatedRoute
  ) {
    this.user = {} as User;
  }

  ngOnInit(): void {
    this.returnUrl = this.route.snapshot.queryParams['returnUrl'] || '/';

    const state = this.route.snapshot.queryParams['state'];
    const state_orig = localStorage.getItem("state");
    this.code = this.route.snapshot.queryParams['code'];
    this.returnUrl = this.route.snapshot.queryParams[this.returnUrlConstant];

    if (this.returnUrl)
      localStorage.setItem(this.returnUrlConstant, this.returnUrl);

    if (!this.code) {
      this.authEmpty = true;
      if (!this.returnUrl) {
        localStorage.removeItem(this.returnUrlConstant);
      }
      return;
    }

    if (state_orig != state) {
      this.authError = true;
    } else {
      this.login();
    }
  }

  login() {
    const nonce = localStorage.getItem("nonce");
    let returnUrl = localStorage.getItem(this.returnUrlConstant) || '/';

    if (!nonce) {
      this.authError = false;
      return;
    }

    if (!returnUrl) {
      returnUrl = "";
    }

    this.service.Login(this.code, nonce)
      .subscribe(
        () => {
          this.router.navigate([returnUrl]);
        },
        () => {
          console.log("There was an error logging in.");
          this.authError = true;
        }
      );
  }
}
